var getChevronRightNotificationColor = function (notificationType) {
    var colorMap = {
        success: '#2B5C1D',
        info: '#34657F',
        warning: '#CAA416'
    };
    return colorMap[notificationType] || '#9E2A20';
};
export default getChevronRightNotificationColor;
